/* eslint-disable max-len */
export const communication = {
  chiffrement: {
    table: {
      title: ' Liste des chiffrements',
      delete_msg: 'Voulez vous supprimer ',
      headerTitle: {
        code: 'Code',
        encrypt_type: 'Type Chiffrement',
        start_date: 'Date Début',
        end_date: 'Date Echéance',
      },
    },
    fiche: {
      title: "Création d'un nouveau chiffrement",
      edit: 'Fiche du chiffrement {{code}}',
      code: 'Code',
      error: 'Erreur',
      error_msg: 'Champ obligatoire',
      type_chiffrement: 'Type Chiffrement',
      placeholder_type: '- Type -',
      extension: 'Extension GPG',
      cle_chiffrement: 'Key-ID GPG',
      pass_phrase: 'Passphrase GPG',
      type_naming: 'Type Nommage',
    },
    widget_chiffrement: {
      title: 'Echéances chiffrement GPG',
      table: {
        code: 'Code',
        date_start: 'Date Début',
        date_end: 'Date Echéance',
        groupe: 'Groupe',
      },
    },
  },
  fichiers_teletransmis: {
    modal: {
      title: {
        visualisation: 'Visualisation du fichier companion',
      },
      buttons: {
        close: 'Fermé',
      },
      columns: {
        tag: 'Balise',
        value: 'Valeur',
      },
    },
    table: {
      header: {
        title: 'Liste des fichiers télétransmis',
      },
      filters: {
        search: {
          place_holder: 'Rechercher un fichier par contenu ...',
        },
        flow: 'Flux',
      },
      columns: {
        flux: 'Flux',
        file_name: 'Nom de fichier',
        banque: 'Banque',
        file_format: 'Format du fichier',
        reference: 'Référence',
        date_transmission: 'Date de transmission',
        size: 'Taille',
      },
    },
  },
  post_traitement: {
    table: {
      header: {
        title: 'Liste des Post-Traitements',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
        update_timestamp: 'Date de modification',
        posttraitement_action: 'Action',
      },
    },
    fiche: {
      title: {
        new_title: "Création d'un nouveau post-traitement",
        edit_title: 'Fiche du post-traitement {{code}}',
        ftp: 'Envoi FTP',
        file_import: 'Import fichiers',
        services: 'Services',
      },
      modal: {
        title: {
          services: 'Sélection de services',
          member: 'Sélection de membres',
          info: 'Liste des mot-clés',
        },
        information: {
          now: 'Date du jour format AAMMJJ',
          year: 'Année sur 2 caractères suivi du quantième',
          hour1: 'Heure au format HHMMSS',
          hour2: 'Heure au format HHMMSSCCC',
          bank_name: 'Nom de la banque',
          interface_code: "Code de l'interface",
          flux_code: 'Code du flux',
          fileformat: 'FileFormat du fichier reçu',
          filename: 'Nom du fichier reçu',
        },
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        add: 'Ajouter',
        close: 'Fermer',
      },
      placeholder: {
        naming: 'Nommage de fichier distant',
        connector: 'Connecteur',
        import_interface: "Interface d'import",
        record_size: 'Taille des enregitrements (cas des lignes fixes)',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        file_format: 'FileFormat',
        retraitement: 'Retraitement',
        record_size: 'Taille des enregistrements',
        connector: 'Connecteur',
        naming: 'Nommage',
        import_interface: "Interface d'import",
        filter: 'Filtre',
        select: 'Séléction',
        noeud: 'Nœud XML',
        balise: 'Balise enregistrement fichier plat',
        position: 'Position information compte',
        longuer: 'Longueur information compte',
        member: 'Membres',
      },
      columns: {
        bank: 'Banque',
        flow: 'Flux',
        code: 'Code',
        name: 'Nom',
        file_format: 'FileFormat',
      },
    },
  },
  fraud_monitor: {
    table: {
      title: 'Liste des règles de Fraud Monitor',
      columns: {
        state: 'Etat',
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        flow: 'Flux',
        update_timestamp: 'Date de modification',
      },
    },
    fiche: {
      title: {
        new_fraud_monitor:
          "Création d'une nouvelle règle de contrôle de Fraud Monitor",
        edit_fraud_monitor: 'Fiche du fraud monitor {{code}}',
        detail: 'Detail',
        filtre: 'Filtre',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        add: 'Ajouter',
      },
      placeholder: {
        currency: 'Devise',
        country: 'Pays',
        flow: 'Selectioner un Flux',
        selectFiliale: 'Toutes les entités',
        selectSociete: 'Tous les sociétés',
        selectBanque: 'Tous les banques',
        selectFlux: 'Tous les flux',
        selectPays: 'Tous les pays',
        selectDevise: 'Toutes les devises',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        flow: 'Flux',
        state: 'Etat',
        rule_type: 'Type de règle',
        period: 'Période en cours',
        approval: 'Approbation',
        filiale: 'Entité',
        societe: 'Societe',
        banque: 'Banque',
        pays: 'Pays',
        devise: 'Devise',
        origin: 'Origin',
        inclus: 'Inclus',
        exclus: 'Exclus',
        tiers_name: 'Nom Liste Tiers',
      },
    },
  },
  connector: {
    table: {
      title: 'Liste des connecteurs',
      services: 'Liste des services',
      columns: {
        code: 'Code',
        state: 'Etat',
        mode: 'Mode',
        name: 'Nom',
        partner: 'Partenaire',
        bank: 'Banque',
        type: 'Type',
        update_timestamp: 'Date de modification',
        planning_status: 'Etat planning',
        recurrency: 'Récurrence',
        frequence: 'Fréquence',
      },
      test_ftp: {
        test: 'Tester la connexion',
        path: 'Chemin',
      },
    },
    fiche: {
      title: {
        edit: 'Fiche du connecteur {{code}}',
        new: "Création d'un nouveau connecteur",
        services: 'Services',
        ebics: 'Ebics',
        ftp: 'FTP',
        swift_net: 'SwiftNet',
        bureau: 'Service Bureau',
        user_id: 'UserID',
        certificat: 'Certificats',
      },
      buttons: {
        add: 'Ajouter',
        validate: 'Valider',
        export: 'Exporter',
        import: 'Importer',
        close: 'Annuler',
        generate_SSH: 'Générer paire de clés SSH',
        migrate: 'Mapping BTF',
      },
      champ_titles: {
        state: 'Etat',
        code: 'Code',
        mode: 'Mode',
        name: 'Nom',
        proxy: 'Proxy',
        protocol: 'Protocole',
        partner: 'Partenaire',
        bank: 'Banque',
        subsidiary: 'Filiale (optionnel)',
        host_id: 'HostID',
        partner_id: 'PartnerID',
        order_id: 'OrderID',
        url: 'URL',
        urlauth: "URL d'authentification",
        version: 'Version',
        login: 'Login',
        password: 'Mot de passe',
        host: 'Hôte',
        ftp_protocole: 'Protocole',
        transmit: 'Emission',
        reception: 'Réception',
        emergency_host: 'Hôte de secours',
        port: 'Port',
        transfer_mode: 'Mode de transfert',
        encryption: 'Chiffrement FTP',
        component: 'Composant FTP',
        encryption_gpg: 'Chiffrement GPG Emission',
        encryption_gpg_reception: 'Chiffrement GPG Réception',
        responder_dn: 'Responder DN',
        responder_bic: 'Responder BIC',
        requestor_dn: 'Requestor DN',
        requestor_bic: 'Requestor BIC',
        service_name: 'Service Name',
        file_info: 'FileInfo',
        ack_responder: 'Ack Responder',
        compression: 'Compression',
        delivery_notification: 'Delivery Notification',
        connector: 'Connecteur',
        bulk_payment_pricing: 'Bulk Payment Pricing',
        bulk_paument_plafond: 'Bulk Payment Plafond',
        payload: 'Payload',
        payload_ext: 'Extension payload',
        passphrase_lau: 'Passphrase LAU',
        companion_file: 'Companion file',
        extension: 'Extension',
        authentification: 'Authentification',
        ssh_key: 'Clé SSH',
        api_method: 'Méthode API',
        api_body: 'Paramètre API',
        api_username: "Nom d'utilisateur",
        api_authorization_type: 'Autorisation',
        api_header: 'En-tête',
        domain: 'Domaine',
        grantype: 'Autorisation Grant Type',
        url_auth: "URL d'authentification",
        ssh_type: 'Type de clé SSH',
        AuthAPIType: 'Authentification Type',
        AuthAPIBody: 'Authentification Body',
      },
      columns: {
        flow: 'Flux',
        code: 'Code',
        name: 'Nom',
        electronic_signature: 'Signature électronique',
        file_format: 'FileFormat',
        file_type: 'FileType',
        beginning_hour: 'Heure début',
        end_time: 'Heure de fin',
        user_id: 'UserId',
        login: 'Login',
        alias: 'Alias',
        serial_number: 'N° série',
        expiration_date: 'Date Exp. AutoSignés',
        expiration_date_signature: 'Date Exp. Signature',
        ini: 'INI',
        hia: 'HIA',
        hpb: 'HPB',
      },
      placeholder: {
        encryption_none: 'Aucun chiffrement',
      },
      modal: {
        title: {
          newService: "Ajout d'un service",
          editService: "Modification d'un service",
          newUserId: "Ajout d'un UserID",
          editUserId: "Modification d'un UserID",
          newCertificat: "Ajout d'un Certificat",
          editCertificat: "Modification d'un Certificat",
          loading: 'chargement...',
          import: 'Importation de certificats',
          gestionEbics: 'Gestion Ebics',
        },
        tabs: {
          general: 'Général',
          planning: 'Planification',
          immediate_execution: 'Exécution immédiate',
        },
        buttons: {
          certificateBackup: 'Récupération du certificat SConnect',
        },
        champ_titles: {
          flow: 'Flux',
          code: 'Code',
          name: 'Nom',
          electronic_signature: 'Signature électronique',
          file_format: 'FileFormat / Request Type',
          messaging: 'Messagerie',
          file_type: 'FileType',
          FileLogicalName: 'File Logical Name',
          meaning: 'Sens',
          user_id: 'UserId',
          login: 'Login',
          certificate: 'Certificat',
          certificate_base_64: 'Certificat Base 64',
          password: 'Mot de passe des certificats importés',
          certificateA: 'Certificat A00',
          certificateE: 'Certificat E00',
          certificateX: 'Certificat X00',
          planning_status: 'Etat de la planification',
          beginning_hour: 'Heure de début',
          end_time: 'Heure de fin',
          recurring: 'Récurrent',
          frequency: 'Fréquence (min)',
          /*
          ebics_msg_namevalue: 'Name value',
          ebics_service_container: 'Service container',
          ebics_service_name: 'Nom du service',
          ebics_service_option: 'Option du service',
          ebics_service_scope: 'Scope du service',
          */
          ebics_msg_namevalue: 'Message Name Value',
          ebics_service_container: 'Service container',
          ebics_service_name: 'Service Name',
          ebics_service_option: 'Service Option',
          ebics_service_scope: 'Service Scope',
          ebics_msg_name_variant: 'Message Name Variant',
          ebics_msg_name_version: 'Message Name Version',
          ebics_format: 'Format',
        },
        columns: {
          CERT: 'Génération des certificats auto-signés',
          HEV: 'Récupération de la version du serveur Ebics',
          INI: 'Envoi de la clé de signature A00',
          HIA: "Envoi des clés de chiffrement et d'authentification",
          Impression: "Impression des lettres d'initialisation Ebics",
          HPB: "Récupération des certificats de chiffrement et d'authentification du partenaire",
          HCA: 'Renouvellement Certificats Autosignés',
          HCS: 'Renouvellement Certificats Autosignés et Certificats clé',
        },
        HCS: {
          next: 'Suivant',
          previous: 'Précédent',
          step: 'Etape',
          wait: 'Renouvellement des certificats en cours ...',
          nextStep:
            'Maintenant insérez votre ancienne clé et tapez votre mot de passe puis cliquez sur Suivant pour continuer.',
          step1: {
            txt1: "Vous etes sur le point de renouvellement vos certificats auto-signés. Vous devez le faire trois mois avant la date l'échéance des certificats.",
            txt2: "Attention ! Toutes les banques ne gèrent pas ce mode de renouvellement. Si c'est le cas, vous devez réinitialiser les certificats manuellement.",
            txt3: 'Insérez votre nouvelle clé puis cliquez sur Suivant pour continuer',
          },
        },
      },
    },
  },
}

